import { useState } from 'react';
import type { DataTableRowEventHandler } from '@/components/custom/erp';
import { TinhThanh } from '@/types/schemas';

interface UseRowSelectionReturn {
  selectedObj: TinhThanh | null;
  selectedRowIndex: string | null;
  handleRowClick: DataTableRowEventHandler<TinhThanh>;
  clearSelection: () => void;
}

export const useRowSelection = (): UseRowSelectionReturn => {
  const [selectedObj, setSelectedObj] = useState<TinhThanh | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick: DataTableRowEventHandler<TinhThanh> = params => {
    setSelectedRowIndex(params.id.toString());
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
